var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 26.25L5.8125 21.5C4.23458 19.26 3.52833 16.5213 3.82631 13.7976C4.12428 11.0739 5.40598 8.55264 7.43088 6.70686C9.45579 4.86109 12.0847 3.81773 14.8242 3.77259C17.5638 3.72744 20.2256 4.68362 22.3102 6.46168C24.3948 8.23973 25.7589 10.7174 26.1465 13.4298C26.534 16.1422 25.9184 18.9027 24.4151 21.1934C22.9119 23.4841 20.6243 25.1475 17.9817 25.8714C15.3392 26.5952 12.5233 26.3298 10.0625 25.125L3.75 26.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.5C11.25 12.6658 11.3158 12.8248 11.4331 12.942C11.5503 13.0592 11.7092 13.125 11.875 13.125C12.0408 13.125 12.1997 13.0592 12.3169 12.942C12.4342 12.8248 12.5 12.6658 12.5 12.5V11.25C12.5 11.0843 12.4342 10.9253 12.3169 10.8081C12.1997 10.6909 12.0408 10.625 11.875 10.625C11.7092 10.625 11.5503 10.6909 11.4331 10.8081C11.3158 10.9253 11.25 11.0843 11.25 11.25V12.5ZM11.25 12.5C11.25 14.1576 11.9085 15.7473 13.0806 16.9194C14.2527 18.0916 15.8424 18.75 17.5 18.75H18.75C18.9158 18.75 19.0747 18.6842 19.1919 18.567C19.3092 18.4498 19.375 18.2908 19.375 18.125C19.375 17.9593 19.3092 17.8003 19.1919 17.6831C19.0747 17.5659 18.9158 17.5 18.75 17.5H17.5C17.3342 17.5 17.1753 17.5659 17.0581 17.6831C16.9408 17.8003 16.875 17.9593 16.875 18.125C16.875 18.2908 16.9408 18.4498 17.0581 18.567C17.1753 18.6842 17.3342 18.75 17.5 18.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/WhatsappIcon.c22839a6.svg";
export { ForwardRef as ReactComponent };